<template>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addArea"
        >新增</el-button>
      </div>

      <div class="icon-group">
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="getAreaList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="areaList"
      size="small"
      height="100%"
      max-height="1200"
      row-key="areaCode"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="left"
        header-align="left"
        prop="areaName"
        label="区域名称"
        width="250"
      > </el-table-column>
      <el-table-column
        align="center"
        prop="areaCode"
        label="区域编码"
        width="200"
      > </el-table-column>
      <el-table-column
        align="center"
        prop="level"
        label="区域等级"
        width="200"
      >
        <template slot-scope="scop">
          <el-tag
            type="success"
            effect="dark"
            v-if="scop.row.level == 1"
          >国家</el-tag>
          <el-tag
            type="info"
            effect="dark"
            v-if="scop.row.level == 2"
          >省份</el-tag>
          <el-tag
            type="warning"
            effect="dark"
            v-if="scop.row.level == 3"
          >城市</el-tag>
          <el-tag
            type="danger"
            effect="dark"
            v-if="scop.row.level == 4"
          >区域</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkArea(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editArea(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteArea(scop.row.id)">
              <Icon size="16">
                <Delete24Regular />
              </Icon>
              <span class="operation-label">删除</span>
            </div>
            <div @click="addChildArea(scop.row.id)">
              <Icon size="16">
                <AddCircle24Regular />
              </Icon>
              <span class="operation-label">添加下级区域</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/查看/修改区域信息 -->
    <el-dialog
      :title="areaStates[areaState]"
      :visible.sync="showDialog"
      width="50%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="area"
          ref="areaForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="mini"
        >
          <el-form-item
            label="区域名称"
            prop="areaName"
          >
            <el-input
            style="width: 200px"
              size="small"
              v-model="area.areaName"
              :disabled="areaState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上级部门"
            prop="parentId"
          >

            <el-select
              style="width: 200px"
              v-model="area.parentId"
              placeholder="请选择部门名称"
              :disabled="areaState == 'check'"
              clearable
              size="small"
            >
              <el-tree
                default-expand-all
                :data="areaList"
                :props="treeProps"
              >
                <div
                  class="custom-tree-node flex items-center"
                  slot-scope="{ node, data }"
                >
                  <el-option
                    :label="node.label"
                    :value="data.id"
                  > </el-option>
                </div>
              </el-tree>
            </el-select>
          </el-form-item>
          <el-form-item
            label="区域编号"
            prop="code"
          >
            <el-input
            style="width: 200px"
              size="small"
              v-model="area.areaCode"
              :disabled="areaState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="区域类型"
            prop="type"
          >
            <el-select
            style="width: 200px"
              v-model="area.level"
              size="small"
              placeholder="请选择"
              :disabled="areaState == 'check'"
            >
              <el-option
                label="国家"
                :value="1"
              > </el-option>
              <el-option
                label="省份"
                :value="2"
              > </el-option>
              <el-option
                label="城市"
                :value="3"
              > </el-option>
              <el-option
                label="区域"
                :value="4"
              > </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="areaState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Edit24Regular, Delete24Regular, Eye24Regular, AddCircle24Regular } from '@v2icons/fluent';
import { Refresh, Search } from '@v2icons/tabler';
import { get, post, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Refresh,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        AddCircle24Regular,
        Search
    },
    props: {
        queryForm: Object,
        checkState: String,
        resetCheckState: Function
    },
    watch: {
        checkState(val) {
            console.log({ val });
            if (val == 'check') {
                // this.resetDepartmentList();
                this.getAreaList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                // this.resetDepartmentList();
                this.queryForm = {};
                this.getAreaList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            loading: false,
            showDialog: false,
            currentAreaId: '',
            areaState: 'add',
            areaStates: {
                add: '新增区域',
                check: '查看区域',
                edit: '编辑区域'
            },
            area: {
                id: '',
                areaName: '',
                areaCode: '',
                level: '',
                parentId: ''
            },
            multipleSelection: [],
            areaList: [],
            rules: {
                areaName: [{ required: true, message: '区域名称不能为空', trigger: 'blur' }],
                areaCode: [{ required: true, message: '区域编号能为空', trigger: 'blur' }],
                level: [{ required: true, message: '区域等级不能为空', trigger: 'blur' }]
            },
            treeProps: {
                children: 'children',
                label: 'areaName'
            },
            isSearch: false,
        };
    },
    created() {
        this.getAreaList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        resetDialog() {
            this.$refs.areaForm.resetFields();
            this.areaState = 'add';
            this.showDialog = false;
        },
        closeDialog() {
            this.resetDialog();
            this.resetProperty();
        },
        //重置属性
        resetProperty() {
            this.area = {
                id: '',
                areaName: '',
                areaCode: '',
                level: '',
                parentId: ''
            };
        },
        submitForm() {
            if (this.areaState == 'add') {
                this.$refs.areaForm.validate((valid) => {
                    if (valid) {
                        post(`/mpp/area/add`, { ...this.area }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                                this.getAreaList();
                                this.resetProperty();
                            }
                        });
                    }
                });
            } else if (this.areaState == 'edit') {
                this.$refs.areaForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.area.parent;
                        post(`/mpp/area/edit`, { ...this.area }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                                this.getAreaList();
                            }
                        });
                    }
                });
            } else if (this.areaState == 'addChild') {
                this.$refs.areaForm.validate((valid) => {
                    if (valid) {
                        delete this.area.parent;
                        post(`/mpp/area/addChild`, { ...this.area }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetDialog();
                                this.getAreaList();
                            }
                        });
                    }
                });
            }
        },

        addArea() {
            this.showDialog = true;
            this.areaState = 'add';
        },
        checkArea(id) {
            this.areaState = 'check';
            this.showDialog = true;
            this.getAreaById(id);
        },
        editArea(areaId) {
            this.showDialog = true;
            this.areaState = 'edit';
            this.getAreaById(areaId);
        },
        addChildArea(id) {
            this.area.parentId = id;
            this.showDialog = true;
            this.areaState = 'addChild';
        },
        deleteArea(id) {
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/area/delete`, { id: id }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getAreaList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshUserList() {
            this.getAreaList();
        },
        getAreaList(query = {}) {
            this.loading = true;
            get(`/mpp/area/treeData`, { keyword: this.queryForm.areaName }).then((res) => {
                if (res.success && res.code == 200) {
                    this.areaList = res.treeData;
                    this.loading = false;
                    console.log(res.treeData);
                }
            });
        },
        getAreaById(areaId) {
            get(`/mpp/area/get`, { id: areaId }).then((res) => {
                if (res.success && res.code == 200) {
                    this.area = { ...this.area, ...res.area };
                    console.log(this.area);
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
        },
        sizeChange(size) {
            this.pageSize = size;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 3px;
    }
    color: #3e8df7;
    span {
        cursor: pointer;
    }
    .el-dropdown-link {
        cursor: pointer;
        font-size: 12px;
        color: #409eff;
    }
}
</style>
